export function fxm(root, undefined) {
  const fx = (obj) => {
    return new fxWrapper(obj);
  };
  fx.version = "0.2";

  const fxSetup = root.fxSetup || {
    rates: {},
    base: "",
  };

  fx.rates = fxSetup.rates;

  fx.base = fxSetup.base;

  fx.settings = {
    from: fxSetup.from || fx.base,
    to: fxSetup.to || fx.base,
  };

  const convert = (val, opts = {}) => {
    if (typeof val === "object" && val.length) {
      for (let i = 0; i < val.length; i++) {
        val[i] = convert(val[i], opts);
      }
      return val;
    }

    const from = opts.from || fx.settings.from;
    const to = opts.to || fx.settings.to;

    return val * getRate(to, from);
  };

  const getRate = (to, from) => {
    const rates = fx.rates;

    rates[fx.base] = 1;

    if (!rates[to] || !rates[from]) {
      from = fx.base; // switch to default
      to = fx.base; // temp fix to make it work in SB
      //throw "fx error"; // temp fix to make it work in SB
    }

    if (from === fx.base) {
      return rates[to];
    }

    if (to === fx.base) {
      return 1 / rates[from];
    }

    return rates[to] * (1 / rates[from]);
  };

  class fxWrapper {
    constructor(val) {
      if (typeof val === "string") {
        this._v = parseFloat(val.replace(/[^0-9-.]/g, ""));
        this._fx = val.replace(/([^A-Za-z])/g, "");
      } else {
        this._v = val;
      }
    }

    convert() {
      const args = Array.prototype.slice.call(arguments);
      args.unshift(this._v);
      return convert.apply(fx, args);
    }

    from(currency) {
      const wrapped = fx(convert(this._v, { from: currency, to: fx.base }));
      wrapped._fx = fx.base;
      return wrapped;
    }

    to(currency) {
      return convert(this._v, {
        from: this._fx ? this._fx : fx.settings.from,
        to: currency,
      });
    }
  }

  fx.prototype = Object.create(fxWrapper.prototype);
  fx.prototype.constructor = fxWrapper;

  if (typeof exports !== "undefined") {
    if (typeof module !== "undefined" && module.exports) {
      exports = module.exports = fx;
    }
    exports.fx = fx;
  } else if (typeof define === "function" && define.amd) {
    define([], function () {
      return fx;
    });
  } else {
    fx.noConflict = (function (previousFx) {
      return function () {
        root.fx = previousFx;
        fx.noConflict = undefined;
        return fx;
      };
    })(root.fx);

    root.fx = fx;
  }

  return fx;
}
